<template>
    <el-dialog :title="sealInfo.type == 'Sign' ? '签名属性' : '签章属性'" class="customDialog attestationDialog" :close-on-click-modal="false" :visible="show" width="640px"
        append-to-body :before-close="closedBtn">
        <div class="dialog_main">
            <div class="info_box">
                <ul>
                    <li>
                        <div class="info_lable">字段</div>
                        <div class="info_content">值</div>
                    </li>
                    <li @click="showInfoClick(sealInfo.commonName)">
                        <div class="info_lable">{{ sealInfo.type == 'Sign' ? '签名人：' : '签章人：' }}</div>
                        <div class="info_content">{{ sealInfo.commonName }}</div>
                    </li>
                    <li @click="showInfoClick(sealInfo.timeInfo)">
                        <div class="info_lable">{{ sealInfo.type == 'Sign' ? '签名时间：' : '签章时间：' }}</div>
                        <div class="info_content">{{ sealInfo.timeInfo }}</div>
                    </li>
                    <li @click="showInfoClick(sealInfo.digestData,true)">
                        <div class="info_lable">原文摘要：</div>
                        <div class="info_content">{{ sealInfo.digestData | ellipsis }}</div>
                    </li>
                    <li @click="showInfoClick(sealInfo.propertyInfo?sealInfo.baseLoc:'')">
                        <div class="info_lable">原文属性：</div>
                        <div class="info_content">{{ sealInfo.propertyInfo?sealInfo.baseLoc:'' }}</div>
                    </li>
                    <li @click="showInfoClick(sealInfo.signature,true)">
                        <div class="info_lable">签名值：</div>
                        <div class="info_content">{{ sealInfo.signature | ellipsis }}</div>
                    </li>
                </ul>
            </div>
            <div class="time_box">{{ clickInfo }}</div>
            <div slot="footer" class="dialog-footer" style="text-align: right;">
                <el-button @click="closedBtn" size="small">&ensp;关闭&ensp;</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {stringToByte,ByteToString} from '@comm/utils/tools'
import { Base64 } from 'js-base64';
export default {
    name: "attributeInfo",
    props: {
        show: { type: Boolean, default: false },
        sealInfo: { type: Object, default: null },
    },
    data() {
        return {
            key: "value",
            clickInfo: ''
        };
    },
    watch: {
    },
    filters: {
		ellipsis(value) {
			if (!value) return "";
			let bytes = ByteToString(stringToByte(Base64.decode(value)))
			return bytes;
		}
	},
    methods: {
        handleOpened() {
            this.$refs.isleft.style = "transform: translateY(0px)";
        },
        closedBtn() {
            this.clickInfo = ''
            this.$emit("update:show", false);
        },
        showInfoClick(data,ellipsis) {
            if(ellipsis){
                data=ByteToString(stringToByte(Base64.decode(data)))
            }
            this.clickInfo = data
        }
    }
};
</script>

<style lang="scss" scoped>

.info_box,
.time_box {
    border-radius: 2px 2px 0px 0px;
    border: 1px solid #E4E6EB;
    height: 204px;
    overflow-y: auto;
    padding: 5px 8px 0;
}

.time_box {
    height: 106px;
    margin-top: 16px;
    padding: 8px 16px;
    font-size: 12px;
    line-height: 18px;
}

.dialog_main {
    position: relative;
    padding: 0 24px;
    height: 460px;
    width: 100%;

    .dialog-footer {
        position: absolute;
        right: 24px;
        bottom: 24px;
    }

    .info_box {
        ul li {
            font-size: 12px;
            line-height: 32px;
            padding: 0 8px;
            height: 32px;
            cursor: pointer;
            display: flex;
            align-items: center;

            &:hover {
                background: rgba(198, 206, 214, 0.2);
            }

            &:focus,
            &:active {
                background: rgba(198, 206, 214, 0.4);
            }

            &:first-child {
                cursor: default;
                color: #B7BFD0;

                &:hover,
                &:focus,
                &:active {
                    background: none;
                }
            }

            .info_lable {
                width: 88px;
            }

            .info_content {
                flex: 1;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                display: block;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/attestationPage/components/attributeInfo.vue